// extracted by mini-css-extract-plugin
module.exports = {"statusMenuItem":"requestSummaryHeaderMenu_statusMenuItem__3lzdh"};